module.exports = __webpack_public_path__ + "mainassets/img/tile-2-4.533b3009.jpg";